<template>
  <mdb-row>
    <mdb-col md="6">
      <mdb-select
        search
        @getValue="getSelectValue"
        v-if="loadReady"
        v-model="labelOptions"
        :visibleOptions="6"
        :label="$t('chain')"
        :placeholder="$t('choose_chain')"
      />
    </mdb-col>
    <mdb-col md="6">
      <ChainMemberSelection
        :retailer-chain-id="retailerChainId"
        :retailer-id="retailerId"
        v-if="loadReady && memberVisibility"
        v-on:member="member"
      />
    </mdb-col>
  </mdb-row>
</template>

<script>
import { mdbSelect, mdbCol, mdbRow } from "mdbvue";
import ChainMemberSelection from "@/components/ChainMemberSelection.vue";

export default {
  name: "ChainSelection",
  components: {
    mdbSelect,
    mdbCol,
    mdbRow,
    ChainMemberSelection
  },
  props: {
    content: Object,
    memberVisibility: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    loadReady: false,
    retailerChainId: 0,
    retailerId: 0,
    chains: [],
    labelOptions: [],
    chainspath: "/1.0/front/retailers/chains"
  }),
  methods: {
    getChainDescription(id) {
      var chain = this.chains.find(chain => chain.retailerchainid === id);
      return chain.description;
    },
    checkContent() {
      this.labelOptions = [];
      var defaultSelection = (this.retailerChainId = this.chains[0].retailerchainid);
      if (this.content != null) {
        defaultSelection = this.retailerChainId = this.content.retailerchain.id;
        if (this.content.hasOwnProperty('retailer_id'))
          this.retailerId = this.content.retailer_id;
      }
      this.chains.forEach(function(chain) {
        this.labelOptions.push({
          text: chain.name + ", id:" + chain.id,
          value: chain.id,
          selected: defaultSelection === chain.id ? true : false
        });
      }, this);
    },
    member(member) {
      this.$emit("member", member, this.retailerChainId, this.getChainDescription(this.retailerChainId));
    },
    getSelectValue(val) {
      this.retailerChainId = val;
      this.$emit("chainid", val);
    }
  },
  watch: {
    content: function(newVal, oldVal) {
      if (newVal !== null) {
        this.checkContent();
      }
      console.log("Prop changed: ", newVal, " | was: ", oldVal);
    }
  },
  mounted() {
    this.$http
      .get(this.chainspath)
      .then(response => {
        if (response.status == 200) {
          this.chains = response.data.chains;
          this.checkContent();
          this.getSelectValue(this.content != null ? this.content.retailerchain.id : response.data.chains[0].retailerchain.id);
          this.loadReady = true;
        } else if (response.status == 401) {
          this.$root.$emit("session_failed");
        }
      })
      .catch(error => {
        this.$root.$emit("session_failed");
        return error;
      });
  }
};
</script>

<style>
.form-control {
  color: #495057;
}
</style>
